<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card flat hover elevation="20">
        <v-card-title primary-title>
            <h4>Войти</h4>
        </v-card-title>
        <v-card-text>
            <v-text-field prepend-icon="person" name="email" label="Электронная почта" v-model="userModel.email"
                          required autofocus></v-text-field>
            <v-text-field prepend-icon="lock" name="password" label="Пароль" type="password"
                          v-model="userModel.password" required></v-text-field>
            <v-switch v-model="userModel.rememberMe" inset
                      label="Запомнить?" color="primary"
                      false-value="0"
                      true-value="1"
            ></v-switch>
        </v-card-text>
        <v-card-actions>
            <v-row>
                <v-col cols="12" xs12>
                    <v-card class="d-flex justify-center" flat>
                        <v-btn color="primary" large block @click="handleSubmit" text>Войти</v-btn>
                    </v-card>
                </v-col>
                <v-col cols="12" xs12>
                    <v-card class="d-flex justify-center" flat>
                        <v-btn color="primary" large block text :href="'https://oauth.vk.com/authorize?client_id='+constConfComp.loginAppVkId
                                                                        + '&redirect_uri=' + constConfComp.baseURLApi
                                                                        + '/authorize/login&display=popup&response_type=code'"
                        >Войти с помощью ВК</v-btn>
                    </v-card>
                </v-col>
                <!--<v-col cols="12" xs12 px-4>
                    <v-card class="d-flex justify-center" flat>
                        <v-menu
                                v-model="showWidgetVK"
                                :close-on-content-click="true"
                                offset-x
                                width="250"
                                min-width="250"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" large block text v-on="on">Войти с помощью ВК</v-btn>
                            </template>
                            <v-card width="250" class="ma-0" style="width: 250px">
                                <v-card-text width="250">
                                    <div id="vk_auth"></div>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </v-card>
                </v-col>-->
                <v-col cols="12" xs12>
                    <v-card class="d-flex justify-center" flat>
                        <v-btn color="primary" large block @click="$router.push({ path: 'send_message_password_reset' })" text>Восстановить доступ</v-btn>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-actions>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
import axios from 'axios'
import { injectVKOpenApi, initVK } from '../../scripts/api/vk.js'
import constConf from '../../constconf'
export default {
    name: 'LoginForm',
    data() {
        return {
            userModel: {
                username: '',
                password: '',
                rememberMe: 0
            },
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            showWidgetVK: false,
            widgetVKLoaded: false
        }
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()
            if (this.userModel.password.length > 0) {
                axios.post(constConf.user.url + '/user/login', this.userModel)
                    .then(response => {
                        if (!response.data.hasOwnProperty('error')) {
                            this.$store.dispatch('bots/loadBots')
                            this.$store.dispatch('user/loadUserByModel', response.data)
                            // axios.post(constConf.user.url + '/user/login', this.userModel).then(response => {
                                this.setcookie('user', 'login', +this.userModel.rememberMe === 1 ? 60 : 0)
                                this.$router.push('bot')
                            // })
                        } else {
                            this.paramsSnackbar.color = 'error'
                            this.paramsSnackbar.text = response.data.error.text
                            this.snackbar = true
                        }
                    })
                    .catch(function (error) {
                        console.error(error)
                        console.error('error')
                    })
            }
        },
        setcookie(cookieName, attribute, addDays) {
            let date = new Date()
            if (addDays) {
                date.setDate(date.getDate() + addDays)
            }
            if (cookieName && attribute) {
                document.cookie = cookieName + '=' + attribute + (addDays ? '; expires=' + date.toUTCString() : '')
            } else { return false }
        }
    },
    watch: {
        showWidgetVK() {
            if (this.showWidgetVK === true && !this.widgetVKLoaded) {
                const { width, onAuth, authUrl } = this
                const options = {
                    width,
                    onAuth,
                    authUrl
                }
                injectVKOpenApi()
                    .then(initVK(true))
                    .then(() => {
                        VK.Widgets.Auth('vk_auth', options)
                    })
                this.widgetVKLoaded = true
            }
        }
    },
    computed: {
        constConfComp() {
            return constConf
        }
    },
    props: {
        /*
             * sets module width in pixels (integer > 300)
             */
        width: {
            type: Number,
            validator: value => !value || value > 300
        },
        /*
             * sets action done during authorization
             * (by default it is navigation to the specified URL with necessary parameters)
             */
        onAuth: {
            type: Function
        },
        authUrl: {
            type: String
        }
    }
}
</script>

<style scoped>

</style>
